import { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import search from "../../assets/images/search.png"; 
import PaginationTable from "../status/PaginationTable";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import axiosInstance from "../../helpers/axios";
import edit from "../../assets/images/edit.png";
import { Button } from 'reactstrap';
import "./index.css";
import plus from "../../assets/images/plus_icon.png";
import InstituteAutocomplete from '../../components/status/ProjectTable/InstituteSearch';
import sortup from '../../assets/images/sort-up.png';
import sortdown from '../../assets/images/sort-down.png';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import ManageProductModal from './ManageProductModal';

import {
  Col,

  Row,

} from 'reactstrap';
import AddProducts from "./AddProducts";
import { useCurrentUser } from '../../hooks/useCurrentUser';
const Products = () =>{
    const [filterInstituteName, setFilterInstituteName] = useState('');
  const productTypeSelected = useSelector(
    (state) => state.ProductTypeFilter.selectedProductType
  );
  const decode = useCurrentUser();
  const user = null;
    const [tableData, setTableData] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [rowsPerPage, setrowsPerPage] = useState(15);
    const [totalFetchRows, setTotalFetchRows] = useState(null);
    const ProcessingFeeTypeArray = ["", "Flat", "Percentage"];
    const FacilityTypeArray = ["", "Dicounted Interest", "Standard Interest", "Hybrid", "Business To Business"];
    const InterestTypeArray = ["", "Reducing", "Flat"];
    const [searchText, setSearchText] = useState("")
    const [isLoading, setIsLoading] = useState(true);
    const [formOpen, setFormOpen] = useState(false);
    const [sortOrder,setSortOrder] = useState(1)
    const [activePage, setActivePage] = useState(15); 
    const [isActive,setIsActive] = useState('')
    const [id,setId]=useState(null)

  useEffect(() => {
    if (productTypeSelected !== "2") {
      setId(null);
      handleInputChange();
      return;
    }

    const setDefaultPersonalLoan = async () => {
      try {
        const res = await axiosInstance.get(`/institute/info/name?name=pers`, {
          headers: {
          },
        });

        const personalLoan = res?.data?.data?.find(
          (item) => item?.brandName === "Personal Loan"
        );

        if (personalLoan?.id) {
          setId(personalLoan.id);

          axiosInstance.get(`/products`, {
            params: {
              perPage: rowsPerPage,
              pageNo: 1,
              instituteId: personalLoan.id,
              sortOrder: sortOrder,
              status: isActive,
            },
            headers: {
            },
          })
            .then((res) => {
              setTableData(res?.data?.data?.details);
              setcurrentPage(res?.data?.data?.pagination?.currentPage);
              setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
              setrowsPerPage(res?.data?.data?.pagination?.perPage);
              setIsLoading(false);
            })
            .catch((error) => {
              console.error("Error fetching Personal Loan products:", error);
              setIsLoading(false);
            });
        }
       
      } catch (error) {
        console.error("Error setting default Personal Loan:", error);
      }
    };

    setDefaultPersonalLoan();
  }, [productTypeSelected]);
    
    useEffect(()=>{
    
    
      if(searchText === ""){
        
        const getprod = `/products?perPage=${rowsPerPage}&pageNo=${currentPage}&sortOrder=${sortOrder}`;

        axiosInstance.get(getprod, {
          headers: {
          },
        })
        .then((res) => {
         
          setTableData(res?.data?.data?.details);
          setcurrentPage(res?.data?.data?.pagination?.currentPage);
          setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
          setrowsPerPage(res?.data?.data?.pagination?.perPage);  
            setIsLoading(false);
        })
        .catch((error) => {
         
          console.error("Error fetching filtered data:", error);
        });
        }
        
    
    },[])


    useEffect(() => {
       handleInputChange(); // Automatically runs whenever sortOrder changes
    }, [sortOrder]);
  //   const getInsituteInfo=(text)=>{
    
  //   const urlGetInstitute=`/institute/info/name?name=${text}`;
      
  //   if(text.length>=4)
  //   {
  //     axiosInstance.get(urlGetInstitute,{
  //       headers:{
  //       }
  //     }).then((res) => {
  //       
  //       setId(res?.data?.data[0]?.id)
  //     });
  
   
  //   }
 
  // }


// const handleStatusChange=(event)=>{
//    setIsLoading(true)
//     let queryParams = {}
//    if(rowsPerPage && currentPage){
//        queryParams.perPage = rowsPerPage;
//        queryParams.pageNo = 1
//        }
//     if(id){
//       queryParams.instituteId = id
//     }
//     if(isActive){
//       queryParams.status=isActive
//     }
//     axiosInstance.get(`/products`, {
//       params: queryParams,
//       headers: {
//       },
//     })
//     .then((res) => {
//       
//       setTableData(res?.data?.data?.details);
//       setcurrentPage(res?.data?.data?.pagination.currentPage);
//       setTotalFetchRows(res?.data?.data?.pagination.totalRows);
//       setrowsPerPage(res?.data?.data?.pagination.perPage);  
//     setIsLoading(false)
//     })
//     .catch((error) => {
//       console.error("Error fetching filtered data:", error);
//     });
// }





  const handleInputChange = (event) => {

   setIsLoading(true)
    let queryParams = {}
   if(rowsPerPage && currentPage){
       queryParams.perPage = rowsPerPage;
       queryParams.pageNo = 1
       }
    if(id){
      queryParams.instituteId = id
    }
    if(sortOrder){
      queryParams.sortOrder=sortOrder
    }
   
    queryParams.status=isActive

    axiosInstance.get(`/products`, {
      params: queryParams,
      headers: {
      },
    })
    .then((res) => {
      setTableData(res?.data?.data?.details);
      setcurrentPage(res?.data?.data?.pagination.currentPage);
      setTotalFetchRows(res?.data?.data?.pagination.totalRows);
      setrowsPerPage(res?.data?.data?.pagination.perPage);  
    setIsLoading(false)
    })
    .catch((error) => {
      console.error("Error fetching filtered data:", error);
    });
  
  // else{
  //   setSearchText("")
  //   const getprod = `/products?perPage=${rowsPerPage}&pageNo=${currentPage}`;

  //   axiosInstance.get(getprod, {
  //     headers: {
  //     },
  //   })
  //   .then((res) => {
  //     
  //     setTableData(res?.data?.data?.details);
  //     setcurrentPage(res?.data?.data?.pagination.currentPage);
  //     setTotalFetchRows(res?.data?.data?.pagination.totalRows);
  //     setrowsPerPage(res?.data?.data?.pagination.perPage);  
   
  //   })
  //   .catch((error) => {
  //     console.error("Error fetching filtered data:", error);
  //   });



  // }
  };





const paginate = (pageNumber) => {
   setIsLoading(true)
    let queryParams = {}
   if(rowsPerPage && currentPage){
       queryParams.perPage = rowsPerPage;
       queryParams.pageNo = pageNumber
       }
    if(id){
      queryParams.instituteId = id
    }
    if(sortOrder){
      queryParams.sortOrder=sortOrder
    }
    
      queryParams.status=isActive
   
    axiosInstance.get(`/products`, {
      params: queryParams,
      headers: {
      },
    })
    .then((res) => {
      setTableData(res?.data?.data?.details);
      setcurrentPage(res?.data?.data?.pagination.currentPage);
      setTotalFetchRows(res?.data?.data?.pagination.totalRows);
      setrowsPerPage(res?.data?.data?.pagination.perPage);  
    setIsLoading(false)
    })
    .catch((error) => {
      console.error("Error fetching filtered data:", error);
    });
 
  // else{
  //   const getprod = `/products?perPage=${rowsPerPage}&pageNo=${pageNumber}`;
  


  // axiosInstance.get(getprod, {
  //   headers: {
  //   },
  // })
  // .then((res) => {
  
  //   setTableData(res?.data?.data?.details);
  //   setcurrentPage(res?.data?.data?.pagination?.currentPage);
  //   setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
  //   setrowsPerPage(res?.data?.data?.pagination?.perPage);  
 
  // })
  // .catch((error) => {
  //   console.error("Error fetching filtered data:", error);
  // });
  // }
   }

const [currentInstituteId,setCurrentInstituteId]=useState(null)
const [productModal, setProductModal] = useState(false);
const [selectedItem, setSelectedItem] = useState(null);
const toggleProductModal = (item) =>{ ;setSelectedItem(item);setProductModal(!productModal);setCurrentInstituteId(item.instituteId)};

const handleProductStatusSuccess = () => {
  setIsLoading(true);
  const getprod = `/products?perPage=${rowsPerPage}&pageNo=${currentPage}&sortOrder=${sortOrder}`;
  axiosInstance.get(getprod, {
    headers: {
    },
  })
  .then((res) => {
    setTableData(res?.data?.data?.details);
    setcurrentPage(res?.data?.data?.pagination?.currentPage);
    setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
    setrowsPerPage(res?.data?.data?.pagination?.perPage);  
    setIsLoading(false);
  })
  .catch((error) => {
    console.error("Error fetching filtered data:", error);
    setIsLoading(false);
  });
};

const handlepageChange = (number) => {


  setIsLoading(true)
  setActivePage(number)
  setrowsPerPage(number);

  let queryParams = {}
  
 if(id){
  queryParams.instituteId=id
 }
  if(rowsPerPage && currentPage){
    queryParams.perPage = number;
    queryParams.pageNo = 1
  }
  if(sortOrder){
    queryParams.sortOrder=sortOrder
  }
  
   queryParams.status=isActive
 
  axiosInstance.get('/products',{
    params:queryParams,
    headers: {
    },
  })
  .then((res)=>{    
    setTableData(res?.data?.data?.details);
    setcurrentPage(res?.data?.data?.pagination?.currentPage);
    setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
    setrowsPerPage(res?.data?.data?.pagination?.perPage); 
      setIsLoading(false);
  })
  .catch((error) => error)

};

const handleCreateProductForm = () => {
    setFormOpen(true);
  };



    return(
          <div style={{width:"100%",backgroundColor:'white',minHeight:'100vh'}}>
            <div>
            <h1 style={{fontFamily:'Inter-Medium',fontSize:'1vw',fontWeight:'500',color:'#D32028',marginTop:'10px'}}>Products</h1>

            <Row >
       <div style={{ display: 'flex', flex: 'wrap',marginTop:'10px',flexDirection:'row',justifyContent:'space-between' }}>
         <div>
         <Col sm="12" md="3" lg="3">
         <div style={{ height: '23px', marginRight: '10px',fontFamily:'Inter'  , position: 'relative', display: 'flex', alignItems: 'center',width:'270px' }}>
         <InstituteAutocomplete
                        defaultValue={productTypeSelected === "2" ? "Personal Loan" : ""}
              onInstituteSelect={(id) => setId(id)} 
              searchIcon={search}
              handleInputChange={handleInputChange}
                placeholder={
                decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
                  ? 'Product Type'
                  : 'Merchant Name'
              }
              height={'36px'}
              borderColor={'#CACCCE'}
            />
       </div>
         </Col>
         </div>
            {/* <div style={{width:'250px'}}> */}
           <Col sm="12" md="3" lg="3" >
             <FormControl  variant="outlined" size="small"  sx={{width:'200px',
              "& label.Mui-focused": {
              color: "#000",
                            },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#e4e6e7",
                      },
                      "&:hover fieldset": {
                        borderColor: "#e4e6e7",
                      },
                      "&.Mui-focused": {
                        borderColor: "#99C4FF", // fallback if fieldset fails
                        boxShadow: "0 0 0 4px #C2DEFF",
                        "& fieldset": {
                          borderWidth: "1px",
                          borderColor: "#4bb6f9ff", // preferred focused color
                        }
                      },
                    }
                  }}>
                <InputLabel>Status</InputLabel>
                <Select
                  label="Status"
                  value={isActive}
                  onChange={(event) => {setIsActive(event.target.value)}}
                    style={{ fontFamily: 'Inter, sans-serif', height: '36px' }}
                >
                <MenuItem value="" sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>All</MenuItem>
                <MenuItem value={1} sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Active</MenuItem>
                 <MenuItem value={0} sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>In-Active</MenuItem>
                </Select>
              </FormControl>
           </Col>
           {/* </div> */}
           <div>
            <Col sm="12" md="3" lg="3" >
              <Button
             variant="contained"
                    onClick={() => handleInputChange(id)}
                    style={{fontFamily:'Inter-Medium',fontSize:'16px',fontWeight:'500', textTransform: 'capitalize',cursor:'pointer',width:'150px',height:'34px',backgroundColor:'#D22129',display:'flex',alignItems:'center',justifyContent:'center',color:'white',borderRadius:'6px',borderColor:'#D22129'}}
                  >
                    Search Results
             </Button>
            </Col>
           </div>
           {(decode?.role === "crm" || decode?.role === "admin")?
             <div>
         <Col sm="12" md="3" lg="3" >
          <Button
                variant="contained"
              style={{fontFamily:'Inter-Medium',fontSize:'16px',fontWeight:'500', textTransform: 'capitalize',cursor:'pointer',width:'180px',height:'34px',backgroundColor:'#D22129',display:'flex',alignItems:'center',justifyContent:'center',color:'white',borderRadius:'6px',borderColor:'#D22129'}}
                 onClick={handleCreateProductForm}
                > <img src={plus} style={{marginRight:'10px'}} alt=""/> Add Product
                <AddProducts
                  setOpenDialog={setFormOpen}
                  openDialog={formOpen}
                  onProductCreated={handleInputChange}
                />
            </Button>
         </Col>
         </div>:null}
       
         {/* <div>
         <Col sm="12" md="10" lg="3" >
           <ManageProducts/>
         </Col>
         </div> */}
         
       </div>
     </Row>
     <ManageProductModal 
       isOpen={productModal} 
       selectedItem={selectedItem} 
       onToggle={() => toggleProductModal(selectedItem)}
       onSuccess={handleProductStatusSuccess}
     />
     {isLoading ? (
       <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%',backgroundColor:'white',height:'100vh'}}>
       <CircularProgress />
     </Box>
     ):(
<>
<div className='tables'  style={{marginTop:'20px'}}>
     <table >
           <thead className='table-heading' style={{width:'100%'}} >
             <tr >
              
               <th className="thead-text" style={{  fontSize: '14px',fontFamily:"Inter" ,width:'12em',borderTopLeftRadius:'8px'}} id="insName">
             <span style={{marginLeft:'10px'}}> Product</span> 
               </th>

               <th className="thead-text" style={{  fontSize: '14px' ,fontFamily:"Inter",width:'14em',paddingLeft:'10px'}} id="coursename">
               { decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? 'Product Type': 'Institute'}
               </th>

               <th className="thead-text" style={{  fontSize: '14px' ,fontFamily:"Inter",width:'8em',paddingLeft:'10px'}} id="coursename">
               Tenure
               </th>
               <th className="thead-text" style={{  fontSize: '14px' ,fontFamily:"Inter",width:'9em'}} id="interest">
               Subvention
               </th>
               <th className="thead-text" style={{  fontSize: '14px' ,fontFamily:"Inter",width:'9em'}} id="interest">
               Standard Int.
               </th>
               <th className="thead-text" style={{  fontSize: '14px' ,fontFamily:"Inter",width:'9em'}} id="interest">
               Student Share
               </th>
               <th className="thead-text" style={{  fontSize: '14px' ,fontFamily:"Inter",width:'6em',paddingLeft:'10px'}} id="pf">
               PF
               </th>
               <th className="thead-text"  style={{  fontSize: '14px',width:'9em',cursor:'pointer',fontFamily:"Inter" }} id="advEmi">
                 Advance EMIs
               </th>
               <th className="thead-text"  style={{  fontSize: '14px',width:'8em',cursor:'pointer',fontFamily:"Inter" }} id="appfromdate">
                   Interest Type
               </th>
               <th className="thead-text"  style={{  fontSize: '14px',width:'8em',cursor:'pointer',fontFamily:"Inter",borderTopRightRadius:'8px' }} id="status">
                   <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px', // adds spacing between text and icon
                  }}> Status
                  {sortOrder === -1 ?   <img
                            src={sortup} 
                            alt="Upward Image"
                            onClick={() => {
                                setSortOrder(1);
                              }}
                            style={{ display: 'block', maxWidth: '13px', maxHeight: '13px', cursor: 'pointer',margin:"10px"}} 
                          /> : <img
                          src={sortdown}   
                          alt="Downward Image"
                          onClick={() => {
                            setSortOrder(-1);
                          }}
                      style={{ display: 'block', maxWidth: '13px', maxHeight: '13px', cursor: 'pointer',margin:"10px" }}
                    />}
                    </span> 
               </th>
               {(decode?.role === "crm" || decode?.role === "admin")? <th className="thead-text"  style={{  fontSize: '14px',width:'8em',cursor:'pointer',fontFamily:"Inter",borderTopRightRadius:'8px' }} id="status">
                   <span style={{marginLeft:'10px'}}> Actions</span> 
               </th>:null}
              

              
               {/* <th className="thead-text"  style={{  fontSize: '13.5px',width:'20em',cursor:'pointer',fontFamily:"Inter" }} id="appfromdate">
                 Action
               </th> */}
             </tr>
           </thead>

       
           
           {tableData?.map((item,index)=>{
               const filterInstitute = filterInstituteName.toLowerCase();
               const currentInstituteName = (item.instituteName || '').toLowerCase();
               if (currentInstituteName.indexOf(filterInstitute) !== -1)
             return(
                 <tbody className='table-body'>
                 <tr  className='table-row' key={index} style={{ lineHeight: '24px' }}>
                 <td style={{color:'#667085',fontFamily:'Inter',fontSize:'14px',paddingLeft:'10px'}}><span style={{fontFamily:'Inter',fontSize:'14px',lineHeight:'1.4em',color:'#667085',fontWeight:'500'}}>{item?.name}</span></td>
                 <td style={{color:'#667085',fontFamily:'Inter',fontSize:'14px',paddingLeft:'10px'}}>
                   {Array.isArray(item?.instituteId) && item.instituteId.length > 0 ? (
                     <span title={item.instituteId.map(inst => inst.name).join(', ')} style={{fontFamily:'Inter',fontSize:'14px',color:'#667085',fontWeight:'500',cursor:'pointer'}}>
                       {item.instituteId.slice(0, 2).map(inst => inst.name).join(', ')}
                       {item.instituteId.length > 2 && (
                         <span style={{marginLeft: '4px'}}>...</span>
                       )}
                     </span>
                   ) : (
                     <span style={{fontFamily:'Inter',fontSize:'14px',color:'#667085',fontWeight:'500'}}>{item?.instituteName}</span>
                   )}
                 </td>
                 <td style={{color:'#667085',fontFamily:'Inter',fontSize:'14px',paddingLeft:'10px'}}><span style={{fontFamily:'Inter',fontSize:'14px',color:'#667085',fontWeight:'500'}}>{item?.tenure}</span></td>
                 <td style={{color:'#667085',fontFamily:'Inter',fontSize:'14px'}}><span style={{fontFamily:'Inter',fontSize:'14px',color:'#667085',fontWeight:'500'}}>{(item?.discountedInterestPercentage*100).toFixed(2)}%</span></td>
                 <td style={{color:'#667085',fontFamily:'Inter',fontSize:'14px'}}><span style={{fontFamily:'Inter',fontSize:'14px',color:'#667085',fontWeight:'500'}}>{(item?.standardInterestPercentage*100).toFixed(2)}%</span></td>
                 <td style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>
                  <span style={{ fontFamily: 'Inter', fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                    {item?.facilityType === 3 ? item.studentShare : 0}
                  </span>
                </td>                 <td style={{color:'#667085',fontFamily:'Inter',fontSize:'14px'}}><span style={{fontFamily:'Inter',fontSize:'14px',color:'#667085',fontWeight:'500'}}>{item?.processingfeeValue}</span></td>
                 <td style={{color:'#667085',fontFamily:'Inter',fontSize:'14px'}}><span style={{fontFamily:'Inter',fontSize:'14px',color:'#667085',fontWeight:'500'}}>{item?.advanceEmis}</span></td>
                 <td style={{color:'#667085',fontFamily:'Inter',fontSize:'14px'}}><span style={{fontFamily:'Inter',fontSize:'14px',color:'#667085',fontWeight:'500'}}>{item?.facilityType===1||item?.facilityType===5?InterestTypeArray[item?.discountedInterestType]:item?.facilityType===2?InterestTypeArray[item?.standardInterestType]:item?.facilityType===3?`${InterestTypeArray[item?.discountedInterestType]}`:null}</span></td>
                 <td style={{color:'#667085',fontFamily:'Inter',fontSize:'14px'}}><span style={{fontFamily:'Inter',fontSize:'14px',color:'#667085',fontWeight:'500'}}>{item?.status===1?"Active":"In-Active"}</span></td>
                 {(decode?.role === "crm" || decode?.role === "admin")?<td style={{color:'#667085',fontFamily:'Inter',fontSize:'14px'}}><span style={{fontFamily:'Inter',fontSize:'14px',color:'#667085',fontWeight:'500'}}><img style={{height:'15px',marginLeft:'1.3em',cursor:'pointer'}} alt="" src={edit} onClick={()=>toggleProductModal(item)}/></span></td>:null}


                 {/* <td title="Manage Institute"><span style={{cursor:'pointer'}}><ManageProducts/></span></td> */}
                 </tr>
                
                 </tbody>
             )
          
                 })}
           
        
         </table>
     </div>
    
     {totalFetchRows ? ( searchText && totalFetchRows <= 100 ?(
      <div style={{display:"flex",justifyContent:"center",marginTop:"10px"}}>
        <div style={{ textAlign: 'center', fontWeight: 'bold',fontFamily:"Inter", fontSize: '14px',marginLeft:'10px',marginBottom:'5px' }}>
              Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage - rowsPerPage+tableData?.length}{" "}
              records of {totalFetchRows} |
             </div>
             <div style={{display:"flex", justifyContent:"space-between",}}>
            &nbsp;<p style={{fontWeight:'600'}}>Rows Per Pages :</p>
          <div>
          <span onClick={()=>handlepageChange(15)} style={{cursor:'pointer',padding:'10px',color: activePage === 15 ? "#D32028" : "black",backgroundColor:activePage === 15 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>15</span>
          <span onClick={()=>handlepageChange(50)} style={{cursor:'pointer',padding:'10px',color: activePage === 50 ? "#D32028" : "black",backgroundColor:activePage === 50 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>50</span>
          <span onClick={()=>handlepageChange(100)} style={{cursor:'pointer',padding:'10px',color: activePage === 100 ? "#D32028" : "black",backgroundColor:activePage === 100 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>100</span>
          <span onClick={()=>handlepageChange(500)} style={{cursor:'pointer',padding:'10px',color: activePage === 500 ? "#D32028" : "black",backgroundColor:activePage === 500 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>500</span>
          </div>
         
         
          </div>
      </div>
              
             
            ):( 
              <div style={{display:"flex",justifyContent:"center",marginTop:"10px"}}>
<div style={{ textAlign: 'center', fontWeight: 'bold',fontFamily:"Inter", fontSize: '14px',marginLeft:'10px',marginBottom:'5px' }}>
           Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage - rowsPerPage+tableData?.length}{" "}
           records of {totalFetchRows} |
          </div>
          <div style={{display:"flex", justifyContent:"space-between",}}>
            <p style={{fontWeight:'600'}}>Rows Per Pages :</p>
          <div>
          <span onClick={()=>handlepageChange(15)} style={{cursor:'pointer',padding:'10px',color: activePage === 15 ? "#D32028" : "black",backgroundColor:activePage === 15 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>15</span>
          <span onClick={()=>handlepageChange(50)} style={{cursor:'pointer',padding:'10px',color: activePage === 50 ? "#D32028" : "black",backgroundColor:activePage === 50 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>50</span>
          <span onClick={()=>handlepageChange(100)} style={{cursor:'pointer',padding:'10px',color: activePage === 100 ? "#D32028" : "black",backgroundColor:activePage === 100 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>100</span>
          <span onClick={()=>handlepageChange(500)} style={{cursor:'pointer',padding:'10px',color: activePage === 500 ? "#D32028" : "black",backgroundColor:activePage === 500 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>500</span>
          </div>
          </div>
              </div>
            )
             
            ) : (
              <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily:"Inter", fontSize: '14px' }}>No Records</div>
            )}
         <PaginationTable
           startPage={searchText !== "" ? 1 : currentPage}
           rowsPerPage={rowsPerPage}
           totalRows={totalFetchRows}
           paginate={paginate}
           searchText={searchText}
         />
</>
     )}

            </div>
     </div>
    )
}
export default Products